import React from 'react';
import { UserIcon, MapPinIcon } from 'lucide-react';
interface RoleSelectorProps {
  currentRole: 'user' | 'manager';
  onRoleChange: (role: 'user' | 'manager') => void;
}
const RoleSelector: React.FC<RoleSelectorProps> = ({
  currentRole,
  onRoleChange
}) => {
  return <div className="bg-white w-full p-4 shadow-md flex justify-center" data-id="element-130">
      <div className="inline-flex rounded-md shadow-sm" role="group" data-id="element-131">
        <button type="button" onClick={() => onRoleChange('user')} className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:text-blue-700 ${currentRole === 'user' ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'}`} data-id="element-132">
          <UserIcon className="w-4 h-4 mr-2" data-id="element-133" />
          User View
        </button>
        <button type="button" onClick={() => onRoleChange('manager')} className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:text-blue-700 ${currentRole === 'manager' ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'}`} data-id="element-134">
          <MapPinIcon className="w-4 h-4 mr-2" data-id="element-135" />
          Map Manager
        </button>
      </div>
    </div>;
};
export default RoleSelector;